import Flux from 'lib/flux';
import ModalConstants from 'constants/modal';
import IntegrationActionCreator from 'action_creators/integration';

const ModalActionCreator = Flux.createActionCreator({
  show(payload) {
    payload = payload || {};
    IntegrationActionCreator.queryParentViewport();
    this.dispatchAction(ModalConstants.SHOW, payload);
  },

  hide() {
    this.dispatchAction(ModalConstants.HIDE);
  },
});

export default ModalActionCreator;
